import React, { useEffect, useRef, useState } from 'react'
import { ChatParent } from './styles/ChatStyle'
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

const MenuSvg = (arg:any) => {
  const { color = "#000000" } = arg
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M4 6H20M4 12H20M4 18H20" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
  )
}

const DocSvg = (arg:any) => {
  const { color = "#000000" } = arg
  return (
    <svg fill={color} width="25px" height="25px" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M 15.5547 53.125 L 40.4453 53.125 C 45.2969 53.125 47.7109 50.6875 47.7109 45.7890 L 47.7109 10.2344 C 47.7109 5.3594 45.2969 2.8750 40.4453 2.8750 L 15.5547 2.8750 C 10.7266 2.8750 8.2891 5.3594 8.2891 10.2344 L 8.2891 45.7890 C 8.2891 50.6875 10.7266 53.125 15.5547 53.125 Z M 15.7422 49.3515 C 13.3281 49.3515 12.0625 48.0625 12.0625 45.7187 L 12.0625 10.3047 C 12.0625 7.9844 13.3281 6.6484 15.7656 6.6484 L 40.2578 6.6484 C 42.6953 6.6484 43.9375 7.9609 43.9375 10.3047 L 43.9375 45.7187 C 43.9375 48.0625 42.6953 49.3515 40.2813 49.3515 Z M 19.1406 16.4453 L 36.9062 16.4453 C 37.7266 16.4453 38.3594 15.7891 38.3594 14.9687 C 38.3594 14.1718 37.7266 13.5625 36.9062 13.5625 L 19.1406 13.5625 C 18.2734 13.5625 17.6640 14.1718 17.6640 14.9687 C 17.6640 15.7891 18.2734 16.4453 19.1406 16.4453 Z M 19.1406 24.625 L 36.9062 24.625 C 37.7266 24.625 38.3594 23.9687 38.3594 23.1484 C 38.3594 22.3515 37.7266 21.7422 36.9062 21.7422 L 19.1406 21.7422 C 18.2734 21.7422 17.6640 22.3515 17.6640 23.1484 C 17.6640 23.9687 18.2734 24.625 19.1406 24.625 Z M 19.1406 32.8047 L 27.5547 32.8047 C 28.375 32.8047 29.0078 32.1718 29.0078 31.3750 C 29.0078 30.5547 28.375 29.9218 27.5547 29.9218 L 19.1406 29.9218 C 18.2734 29.9218 17.6640 30.5547 17.6640 31.3750 C 17.6640 32.1718 18.2734 32.8047 19.1406 32.8047 Z"></path></g></svg>
  )
}

const FileSvg = (arg:any) => {
  const { color = "#000000" } = arg
  return (
    <svg width="30px" height="64px" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg" fill={color}><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g fill="none" fill-rule="evenodd" stroke={color} stroke-linecap="round" stroke-linejoin="round" transform="translate(4 3)"> <path d="m8.5 14.5h2c1.1045695 0 2-.8954305 2-2v-8l-4-4h-6c-1.1045695 0-2 .8954305-2 2v10c0 1.1045695.8954305 2 2 2h2"></path> <path d="m3.5 7.5 3-3 3 3"></path> <path d="m6.5 4.5v11"></path> </g> </g></svg>
  )
}

const ScanFileSvg = (arg:any) => {
  const { color = "#000000" } = arg
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 8a1 1 0 0 1-2 0V5.923c0-.76.082-1.185.319-1.627.223-.419.558-.754.977-.977C4.738 3.082 5.162 3 5.923 3H8a1 1 0 0 1 0 2H5.923c-.459 0-.57.022-.684.082a.364.364 0 0 0-.157.157c-.06.113-.082.225-.082.684V8zm3 11a1 1 0 1 1 0 2H5.923c-.76 0-1.185-.082-1.627-.319a2.363 2.363 0 0 1-.977-.977C3.082 19.262 3 18.838 3 18.077V16a1 1 0 1 1 2 0v2.077c0 .459.022.57.082.684.038.07.087.12.157.157.113.06.225.082.684.082H8zm7-15a1 1 0 0 0 1 1h2.077c.459 0 .57.022.684.082.07.038.12.087.157.157.06.113.082.225.082.684V8a1 1 0 1 0 2 0V5.923c0-.76-.082-1.185-.319-1.627a2.363 2.363 0 0 0-.977-.977C19.262 3.082 18.838 3 18.077 3H16a1 1 0 0 0-1 1zm4 12a1 1 0 1 1 2 0v2.077c0 .76-.082 1.185-.319 1.627a2.364 2.364 0 0 1-.977.977c-.442.237-.866.319-1.627.319H16a1 1 0 1 1 0-2h2.077c.459 0 .57-.022.684-.082a.363.363 0 0 0 .157-.157c.06-.113.082-.225.082-.684V16zM3 11a1 1 0 1 0 0 2h18a1 1 0 1 0 0-2H3z" fill={color}></path></g></svg>
  )
}

const LeftArrowSvg = (arg:any) => {
  const { color = "#000000" } = arg
  return (
    <svg width={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7071 4.29289C12.0976 4.68342 12.0976 5.31658 11.7071 5.70711L6.41421 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H6.41421L11.7071 18.2929C12.0976 18.6834 12.0976 19.3166 11.7071 19.7071C11.3166 20.0976 10.6834 20.0976 10.2929 19.7071L3.29289 12.7071C3.10536 12.5196 3 12.2652 3 12C3 11.7348 3.10536 11.4804 3.29289 11.2929L10.2929 4.29289C10.6834 3.90237 11.3166 3.90237 11.7071 4.29289Z" fill={color}></path> </g></svg>
  )
}

const useGlobalKeyDown = (callback: (event: KeyboardEvent) => void) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      callback(event);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [callback]);
};

interface aiChatProps{
  func?:{
    sendPrompt?:()=>void
  }
}

const Chat:React.FC<aiChatProps>=(props:any) => {

  const{func}=props

  const {
    sendPrompt,
    storeSystemPrompt,
    updateSystemDetails,
    getSystemDetails
    }=func||{}

  const [message, setMessage] = useState<[]|any>(null)
  const [openModal,setOpenModal]=useState(false)
  const [typing,setTyping]=useState(false)
  const [systemPrompt,setSystemPrompt]=useState<any>({prompt:"your are an dm recruitment assistant"})
  const [file, setFile] = useState<File | null>(null);
  const [dragActive, setDragActive] = useState(false);
  const [copied, setCopied] = useState(false);

  const divRef = useRef<HTMLDivElement | null>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (func && getSystemDetails) {
        getSystemDetails()
            .then(async (response:any) => {
                return response.json(); 
            })
            .then((data:any) => {
                console.log("✅ Parsed JSON Data:", data);
                if(data?.status==200){
                  setSystemPrompt({...data?.data?.data_list?.[0]})
                } 
            })
            .catch((error:any) => {
                console.error("❌ API Call Failed:", error);
            });
    }
}, [func, getSystemDetails, props]);


  const scrollToBottom = () => {
    if (divRef.current) {
      divRef.current.scrollTop = divRef.current.scrollHeight;
    }
  };

  const systemPromptHandleChange=(value:string)=>{
    setSystemPrompt({...systemPrompt,prompt:value})
  }

  const sendMessage = async() => {
    if (file) {
      setTyping(true)
      const formData = new FormData();
    formData.append('user_prompt', file);
    formData.append('system_prompt', systemPrompt?.prompt);


      console.log('qqq-00009',formData,file)


      if(func&&sendPrompt){

        sendPrompt(formData)
        .then((response:any) => {

          if(response.status==200){
           setMessage(response)
           console.log('qqq-111',response)
          }else{
            console.error("qqq-111","error",response)
          }

          setTyping(false)
        })
        .catch((error:any) => {
            console.error('❌ Error:', error);
            setTyping(false)
        });
    
      }

      setTimeout(() => {
        scrollToBottom()
      }, 0);
    }

  }

  const isModelOpenAndClose=()=>{
    setOpenModal(!openModal)
  }

  const clearChat=()=>{
      setFile(null)
      if (inputRef.current) {
        inputRef.current.value = ''; // clear input value
      }
      setMessage(null)
  }

  const handleKeyDown = (event: KeyboardEvent) => {
    if(event.key === "Enter"&&!openModal){
      event.preventDefault();
     sendMessage()
    }else if(event.ctrlKey && event.code === "Space"&&!openModal){
      event.preventDefault();
     clearChat()
    }else if(event.ctrlKey && event.key === "ArrowUp"){
      event.preventDefault();
      isModelOpenAndClose()
    }
  };

  const saveSystemPrompt=()=>{
    const savePrompt=(payload:any)=>{
      storeSystemPrompt(payload)
      .then((response:any) => {

        if(response.status==200){
          setSystemPrompt({...response?.data?.data})
        }else{
          console.error("error",response)
        }

        setTyping(false)
      })
      .catch((error:any) => {
          console.error('❌ Error:', error);
          setTyping(false)
      });
    }

    const editPrompt=(payload:any)=>{
      updateSystemDetails(payload)
      .then((response:any) => {

        if(response.status==200){
          setSystemPrompt({...response?.data?.data_list})
        }else{
          console.error("qqq-111","error",response)
        }

        setTyping(false)
      })
      .catch((error:any) => {
          console.error('❌ Error:', error);
          setTyping(false)
      });
    }
    if(func&& storeSystemPrompt&&(!systemPrompt?.["__id"]||!Object.keys(systemPrompt).includes('__id'))){
      const payload={
        prompt:systemPrompt?.prompt
      }
      savePrompt(payload)
    }else{
      editPrompt(systemPrompt)
    }

    isModelOpenAndClose()
  }

     // Apply the global keydown event listener
  useGlobalKeyDown(handleKeyDown);


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragActive(false);

    const droppedFile = e.dataTransfer.files?.[0];
    if (droppedFile) {
      setFile(droppedFile);
    }
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  const handleRemoveFile = () => {
    setFile(null);
    if (inputRef.current) {
      inputRef.current.value = ''; // clear input value
    }
  };


  const handleCopy = () => {
    navigator.clipboard.writeText(message?.message).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2s
    });
  };

  console.log('qqq-123',file)

  return (
    <ChatParent >
      <div role="button" className='ai-menu-container' >
        <div role='button' className='ai-menu-icon-container'>
          <MenuSvg color="#2f3030" />
        </div>
        <div className='ai-menu-button-list'>
          <p role="button" onClick={isModelOpenAndClose} className='ai-menu-drop-down-options'>
            Prompt <span className='ai-sub-text ai-text-10'>( Ctrl + UpArrow)</span>
          </p>
          <p role="button" onClick={clearChat} className='ai-menu-drop-down-options red-color-text'>
            Clear Chat <span className='ai-sub-text ai-text-10'> ( Crtl + Space )</span>
          </p>
        </div>
      </div>

      {(message)&& <div className='ai-back-icon-container' role='button' onClick={()=>clearChat()}>
      <LeftArrowSvg color="#2e59e6"/>
      </div>}

      {(!message)&&<div className={`ai-file-container ${dragActive ? 'drag-active' : ''}`} 
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}>
         <input
        type="file"
        accept=".pdf,.doc,.docx,.txt"
        ref={inputRef}
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <div className='ai-file-inner-container'>
          <div className='ai-file-upload-icon'>
            {!file&&<FileSvg color="#2e59e6"/>}
            {file&&<DocSvg color="#2e59e6"/>}
          </div>
          {!file&&<div className='ai-uploader-text-container'>
          <p className='ai-sub-text ai-text-14'> <span className='ai-highlighted-text' role='button' onClick={handleClick}>Click here </span> to upload your file or drag</p>
          <p className='ai-uploader-sub-text'>Supported Format : Pdf, Doc, Docx, Txt (max 1 file) </p>
          </div>}
          {file&&<div className='ai-uploader-text-container'>
          <p className='ai-sub-text ai-text-14'> <span className='ai-highlighted-text'>{file?.name}</span> <span role='button' onClick={handleRemoveFile} className='ai-upload-remove-icon'>X</span></p>
          <p className='ai-uploader-sub-text'>Supported Format : Pdf, Doc, Docx, Txt (max 1 file) </p>
          </div>}
          {file&&<button className='message-send-button ai-w-full' onClick={sendMessage}>
          <div className='message-send-button-icon' >
                <ScanFileSvg color="#FFFFFF" />
          </div>
          <span className='ai-button-text'>Send to Analysis</span>
          </button>}
        </div>
      </div>}

     {(message)&& <div className='ai-display-parent-container'>
            <h1 className='ai-result-chat-container'>Result of Analysis : </h1>

            <div className='ai-msg-container'>
              <div className='ai-copy-button-container'>
              <button 
        onClick={handleCopy}
        style={{
          backgroundColor: copied ? '#4caf50' : '#eee',
          color: copied ? 'white' : '#333',
          border: 'none',
          padding: '6px 10px',
          borderRadius: '4px',
          cursor: 'pointer',
          fontSize: '0.9rem'
        }}
      >
        {copied ? 'Copied!' : 'Copy'}
      </button>
              </div>
              <ReactMarkdown remarkPlugins={[remarkGfm]}  rehypePlugins={[rehypeRaw]}>{message?.message}</ReactMarkdown>
            </div>
      </div>}


      {/* --------------------Modals-------------------------- */}

    {typing&&<div className='ai-user-prompt-modal'>
      <div className='ai-file-scaning-animation-contaier'>
        <div className="scanner-container">
        <div className="file-icon">FILE</div>
        <div className="scan-line"></div>
      </div>
      <p className='ai-file-analys-text'>Please Wait we are Analysing . . .</p>
       </div>
    </div>}

    {openModal&&<div className='ai-user-prompt-modal'>
            <section className='ai-prompt-parent'>
              <h1 className='ai-prompt-title'>AI Prompt</h1>
                <textarea value={systemPrompt?.prompt} className='ai-prompt-input' placeholder='Write a prompt, How I want to work !' onChange={(e:any)=>{systemPromptHandleChange(e?.target?.value)}}/>
                <div className='ai-prompt-button-container'>
                  <button onClick={isModelOpenAndClose} className='ai-prompt-secondary-button'>Cancel</button>
                  <button className='ai-prompt-primary-button' onClick={saveSystemPrompt}>Save</button>
                </div>
            </section>
      </div>}

    </ChatParent>
  )
}

export default Chat